import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from '@material-ui/core';
import { MenuItemLink, usePermissions, useTranslate } from 'react-admin';
import BusinessIcon from '@material-ui/icons/Business';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SchoolIcon from '@material-ui/icons/School';
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import WebIcon from '@material-ui/icons/Web';
import SpacerTop from './CustomMenuItem.styles';

const Menu = ({ onMenuClick, logout }) => {
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { loaded } = usePermissions();
  const translate = useTranslate();
  return loaded ? (
    <SpacerTop>
      <MenuItemLink
        data-testid="menu-item"
        leftIcon={<BusinessIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.clients.title')}
        to="/clients"
      />
      <MenuItemLink
        data-testid="menu-item"
        leftIcon={<MenuBookIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.courses.title')}
        to="/courses"
      />
      <MenuItemLink
        data-testid="menu-item"
        leftIcon={<WebIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.units.title')}
        to="/units"
      />
      <MenuItemLink
        data-testid="menu-item"
        leftIcon={<MonetizationOnIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.licenses.title')}
        to="/licenses"
      />
      <MenuItemLink
        leftIcon={<MoveToInboxIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.scorms.title')}
        to="/scorms"
      />
      <MenuItemLink
        leftIcon={<SchoolIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.students.title')}
        to="/students"
      />
      <MenuItemLink
        leftIcon={<PeopleAltIcon />}
        onClick={onMenuClick}
        primaryText={translate('custom.users.title')}
        to="/users"
      />
      {isXSmall && logout}
    </SpacerTop>
  ) : null;
};

Menu.propTypes = {
  logout: PropTypes.element,
  onMenuClick: PropTypes.func,
};

Menu.defaultProps = {
  logout: <></>,
  onMenuClick: () => {},
};

export default Menu;
